<template>
  <van-popup :value="true" :closeable="false" :close-on-click-overlay="true" class="popup-stampante" :class="{ 'fatture': fatturazioneElettronica }" @open="onOpen" @close="onClose" @click-overlay="onClose">
    <van-tabs v-model="activeName" @change="onChangeTab">
      <van-tab v-for="azienda in multiazienda" :key="azienda.codice" :title="azienda.scontrino.descrizione" :name="azienda.codice">
        <interfaccia :showDettaglio="showDettaglio" :richiestaChiusura="richiestaChiusura" :numStampante="azienda.idScontriniMachine" :context="context" @eventi="eventiInterfaccia"/>
      </van-tab>
    </van-tabs>
    <h4 class="info-center red blink" v-if="erroreAllineamento">Attenzione! I numeratori in cloud non risultano allineati! Aggiornare la pagina per riallineare.</h4>
    <stato-servizi :fatture="fatturazioneElettronica" :multiAzienda="true" @dettaglio="showDettaglio = !showDettaglio"/>
    <fatture-elettroniche v-if="fatturazioneElettronica"/>
  </van-popup>
</template>

<script>
import StatoServizi from '../statoServizi'
import FattureElettroniche from '../fattureElettroniche'
import configurazioni from '@/services/configurazioniService'
import { confermaOperazione } from '@/mixins/confermaOperazione'
import { insomnia } from '@/mixins/insomnia.js'
// Verificare uso plugin per nuove stampanti !!!
import Interfaccia from './interfaccia'
/* import rch from '../stampanti/rch'
import epson from '../stampanti/epson'
import ditron from '../stampanti/ditron' */

export default {
  components: {
    StatoServizi,
    FattureElettroniche,
    Interfaccia
  },
  mixins: [confermaOperazione, insomnia],
  props: {
    context: Object
  },
  data() {
    return {
      showDettaglio: false,
      activeName: null,
      multiazienda: [],
      richiestaChiusura: false,
      erroreAllineamento: false,
      fatturazioneElettronica: false
    }
  },
  async mounted() {
    this.fatturazioneElettronica = !!localStorage.getItem('display_fe')
    const multiazienda = await configurazioni.getConfigurazione('display_generale', 'multiazienda')
    if (multiazienda) {
      this.multiazienda = multiazienda
    }
    this.testInterval = setInterval(async () => {
      const status = await this.getProcessStatus(null) // TODO: gestire invio this.infoStampante
      this.$store.commit('SET_SERVICE_STATUS', status)
    }, 4000)
    this.avviaTimerChiudi()
  },
  computed: {
    statoServizi() {
      return this.$store.getters.serviceStatus
    },
    bloccaChiusura() {
      let blocca = false
      for (const s of this.statoServizi) {
        if (!s.health || s.health === '---') {
          blocca = true
        }
      }
      return blocca
    }
  },
  methods: {
    onChangeTab(name) {

    },
    async eventiInterfaccia({ tipo, payload }) {
    },
    avviaTimerChiudi(ritardo) {
      this.timerChiudi = setInterval(() => {
        if (!this.bloccaChiusura) {
          clearInterval(this.timerChiudi)
          this.onClose()
        }
      }, ritardo || 30000)
    },
    fermaTimerChiudi() {
      clearInterval(this.timerChiudi)
    },
    async onOpen() {
      const status = await this.getProcessStatus(null)
      this.$store.commit('SET_SERVICE_STATUS', status)
      const verificaNumeratori = await configurazioni.verificaAllineamentoNumeratori()
      if (!['ok', '---'].includes(verificaNumeratori.status)) {
        this.erroreAllineamento = true
      }
    },
    async onClose() {
      this.richiestaChiusura = true
      await this.$nextTick()
      clearInterval(this.testInterval)
      // TODO: Mettere su interfaccia
      /*       if (!this.infoStampante.errore || this.infoStampante.errCode === 'STATUS_ERROR') {
        this.modoReg()
        setTimeout(() => { this.context.inviaBenvenutoAMF = true }, 500)
      } */
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

  .popup-stampante {
    width: 40vw;
    height: 60vh; /* 47 Attenzione lasciare spazio per pulsanti aggiornamento */
    &.fatture {
      height: 80vh;
    }
  }

  @media all and (max-width: 1800px) {
    .popup-stampante {
      width: 50vw;
      height: 67vh;
      &.fatture {
        height: 87vh;
      }
    }
  }

  @media all and (max-width: 1400px) {
    .popup-stampante {
      width: 55vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
      &.fatture {
        height: 92vh;
      }
    }
  }

  @media all and (max-width: 1024px) {
    .popup-stampante {
      width: 80vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
      &.fatture {
        height: 92vh;
      }
    }
  }

  .info-center {
    text-align: center;
    &.red {
      color: red;
    }
    &.orange {
      color: #ff8800;
    }
  }
  .testo-inattiva {
    color: red;
    font-weight: bold;
  }
  .popup-stampante .van-cell {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .blink {
    animation: blinker 1s step-start infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
</style>
